import React from 'react';

const Rank = ({ name, id }) => {
  return (
    <div>
      <div className='white f3'>
        {`Hello ${name}, your current p10 rating is...`}
      </div>
      <div className='white f1'>
        {id}
      </div>
    </div>
  );
}

export default Rank;